module.exports = __webpack_public_path__ + "static/media/thumbnail.945c591e.jpg";